import { FormValidations } from "features/shared/forms/hooks/useForm";
import PatternValidatonRule from "features/validation/rules/PatternValidatonRule";

export const phoneFormValidations = (): FormValidations => {
  return {
    DESC_TMTELEFON: {
      required: true,
      type: "Pattern",
      regex: /^(\+420|\+421)? ?[1-9][0-9]{2} ?[0-9]{3} ?[0-9]{3}$/,
      message: "invalidPhone"
    } as PatternValidatonRule
  };
};
